<template>
  <button
    type="button"
    class="w-11 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 relative inline-flex flex-shrink-0 h-6 transition-colors duration-200 ease-in-out border-2 border-transparent rounded-full cursor-pointer"
    :class="{'bg-indigo-600': modelValue == true, 'bg-gray-200':modelValue==false}"
    role="switch"
    aria-checked="false"
    @click="onClick"
  >
    <span
      aria-hidden="true"
      class="ring-0 inline-block w-5 h-5 transition duration-200 ease-in-out transform bg-white rounded-full shadow pointer-events-none"
      :class="{'translate-x-5': modelValue == true, 'translate-x-0':modelValue==false}"
    />
  </button>
</template>
<script>
export default {
  name: "v-input-switch",
  props: {
    modelValue: {
      required: true,
      validator: (value) => {
        return _.isBoolean(value);
      }
    },
    onClick: {
      required: true,
      type: Function
    }
  },
  emits: ["update:modelValue"],
  watch: {
    "modelValue"() {
      this.$emit("update:modelValue", this.modelValue);
    }
  }
};
</script>
